import { useSelectedReportId } from 'modules/campaigns/modules/campaigns-reports/hooks/useSelectedReportId';
import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { CAMPAIGN_REPORT_ID } from '../modules/campaigns/modules/campaigns-reports/config/reports/campaign/campaignReportId';
import { CREATIVE_REPORT_ID } from '../modules/campaigns/modules/campaigns-reports/config/reports/creative/creativeReportId';
import { useIsHeavyAccount } from './useIsHeavyAccount';

export const useIsHeavyReport = () => {
    const [reportId] = useSelectedReportId();
    const campaignsReport = useIsHeavyAccount();
    const creativesReport = useConfigMatch({ [FEATURE_FLAGS.HEAVY_CREATIVES_REPORT]: 'true' });

    switch (reportId) {
        case CAMPAIGN_REPORT_ID:
            return campaignsReport;
        case CREATIVE_REPORT_ID:
            return creativesReport;
        default:
            return false;
    }
};
